import React from 'react';
import { Title, Button, Wrapper, Content, Illustration } from './styled';
import { colors } from '../../theme/colors';
import { Text } from '../../components/Typography';
var Page500 = function (_a) {
    var description = _a.description, title = _a.title, onClickMainPage = _a.onClickMainPage;
    return (React.createElement(Wrapper, null,
        React.createElement("div", null,
            React.createElement(Illustration, null)),
        React.createElement(Content, null,
            React.createElement(Title, { level: 3 }, title || 'Технические работы'),
            React.createElement(Text, { color: colors.primaryText }, description || React.createElement(React.Fragment, null,
                "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F\u00A0\u2014",
                React.createElement("br", null),
                "\u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u0439\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043C\u0438\u043D\u0443\u0442")),
            React.createElement(Button, { onClick: onClickMainPage, type: 'primary' }, "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"))));
};
export default Page500;
//# sourceMappingURL=Page500.js.map